<template>
    <div class="section-box">
        <el-tabs v-model="form.status" type="card" class="customer-tabs-mg" @tab-click="handleSearch()">
            <el-tab-pane v-for="(item, index) in tabList" :label="item.value" :name="item.key + ''" :key="index+''">
            </el-tab-pane>
        </el-tabs>
        <div class="customer-list-brand">
            <div class="next-button">
                <el-button size="small" type="primary" icon="el-icon-plus" plain @click="openBrandModl()">新增</el-button>
                <el-button size="small" type="primary" @click="handleSearch">查询</el-button>
                <el-button size="small" type="success" @click="handleReset">重置</el-button>
            </div>
        </div>
        <!-- eslint-disable  -->
        <el-table
                ref='table'
                :stripe="true"
                :data="tableData"
                style="width: 100%"
                height="670"
                border
                v-loading="listLoading"
                :key="toggleIndex"
        >
            <el-table-column label="品牌编号">
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-input type="number" size="mini" v-model="form.id" placeholder="请输入编号搜索"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.id || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="品牌名称">
                <el-table-column show-overflow-tooltip >
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model.trim="form.brandName" placeholder="请输入品牌名称搜索"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.brandName || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="品牌英文名">
                <el-table-column show-overflow-tooltip >
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model.trim="form.pinyin" placeholder="请输入品牌英文名名称搜索"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.pinyin || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="品牌LOGO">
                <template slot-scope="scope">
                    <span v-if="scope.row.brandImage">
                            <img :src="scope.row.brandImage" @click="openimg(scope.row.brandImage)" class="hands" style="width: 200px;height: 80px;"/>
                    </span>
                    <span v-else>--</span>
                </template>
            </el-table-column>
            <el-table-column label="官方链接">
                <el-table-column show-overflow-tooltip >
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model.trim="form.brandWebsite" placeholder="请输入关键字搜索"/>
                    </template>
                    <template slot-scope="scope">
                        <span @click="opensrc(scope.row.brandWebsite)" class="hands">{{scope.row.brandWebsite || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="品牌介绍">
                <el-table-column show-overflow-tooltip >
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model.trim="form.brandIntroduce" placeholder="请输入关键字搜索"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.brandIntroduce || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="操作" fixed="right"  width="200">
                <template slot-scope="scope">
                    <el-button size="mini" v-if="scope.row.status" @click="openmodfMod(scope.row)">修改</el-button>
                    <el-button size="mini" type="primary" v-if="!scope.row.status" @click="confirmZF(true,scope.row.id)">恢复</el-button>
                    <el-button size="mini" type="warning" v-if="scope.row.status" @click="openZFModel(scope.row)">作废</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div style="margin: 10px;overflow: hidden">
            <div style="float: right;" v-show="tableData.length">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="form.pageNum"
                        :page-sizes="[10, 20, 50, 100, 200]"
                        :page-size="form.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total">
                </el-pagination>
            </div>
        </div>
        <add-brand
                ref="addBrand"
                v-if="showBrand"
                :current-param="currentlevelParam"
                @close="closeBrand"
                @refreshList="successbrand"
        >
        </add-brand>
        <el-dialog :visible.sync="dialogVisible" :close-on-click-modal="false" :append-to-body="true">
            <img width="100%" :src="dialogImageUrl" alt="" />
        </el-dialog>
        <el-dialog
                title="作废操作"
                :visible="showZFModel"
                :close-on-click-modal="!showZFModel"
                :before-close="closeZFModel"
                width="500px"
        >
            <div class="pad-20">
                <h3>您正在执行作废操作，一旦确认，【{{zfname}}】品牌将被作废，请谨慎操作</h3>
                <div class="dialog-footer" style="text-align: center;margin-top: 40px;" slot="footer">
                    <el-button type="primary" @click="confirmZF(false,-2)">确认作废</el-button>
                </div>
            </div>
        </el-dialog>

    </div>
</template>

<script>
    import { getbrandList,updatebrand} from "@/service/dataFrame";
    import addBrand from './index/addBrand';
    import { getStorageUserRoleId } from '@/utils/store'
    export default {
        name: "brandLibrary",
        components:{addBrand},
        data(){
            return{
                tableData:[],
                listLoading:false,
                currentlevelParam:{},
                form:{
                    id:'',
                    brandName:'',
                    pinyin:'',
                    brandWebsite:'',
                    brandIntroduce:'',
                    status:'1',
                    pageNum: 1,
                    pageSize: 10
                },
                total: 0,
                searchData:{},
                toggleIndex:0,
                tabList:[
                    {key:'1',value:'有效品牌'},
                    {key:'0',value:'无效品牌'},
                ],
                oraginForm:{},
                showBrand:false,
                showZFModel:false,//作废
                zfname:'',
                zfModl:{},
                dialogVisible:false,
                dialogImageUrl: "",     //点击查看的url
            }
        },
        created() {
            this.oraginForm = JSON.parse(JSON.stringify(this.form))
            this.tableData = [];
            this.handleSearch()
        },
        methods:{
            openimg(data){
                if(data){
                    this.dialogVisible=true;
                    this.dialogImageUrl=data;
                }
            },
            opensrc(data){
                if(data){
                  window.open(data)
                }
            },
            successbrand(){
                this.getBrandlist();
            },
            handleSearch(){
                this.searchData = Object.assign({}, this.form)
                this.form.pageNum = 1;
                this.searchData.pageNum = 1;
                this.getBrandlist();
            },
            async getBrandlist(){
                this.listLoading = true;
                this.toggleIndex=this.form.status;
                let data = JSON.parse(JSON.stringify(this.searchData))
                !data.id && delete data.id
                !data.brandIntroduce && delete data.brandIntroduce
                !data.brandName && delete data.brandName
                !data.brandWebsite  && delete data.brandWebsite
                !data.pinyin  && delete data.pinyin
                !data.description && delete data.description
                data.status=this.form.status==1?true:false
                let res = await getbrandList(data)
                this.listLoading = false
                if(res.Result != 1) {
                    return this.$message.error('获取失败请联系开发人员')
                }
                this.tableData = res.Data.datas || [];
                this.total = res.Data.total;
                this.$nextTick(() => {
                    this.$refs.table.doLayout()
                })
            },
            handleSizeChange(val) {
                if (this.listLoading) return
                this.form.pageNum = 1
                this.form.pageSize = val;
                this.searchData.pageNum = 1
                this.searchData.pageSize = val;
                this.getBrandlist();
            },
            handleCurrentChange(val) {
                if (this.listLoading) return
                this.form.pageNum = val;
                this.searchData.pageNum = val;
                this.getBrandlist();
            },
            openZFModel(data){
                this.showZFModel=true;
                this.zfname=data.brandName;
                this.zfModl={
                    id:data.id,
                }
            },
            confirmZF(data,id){
                let param={
                    status:data,
                    userId:getStorageUserRoleId()
                }
                if(id>-1){
                    param.id=id
                }else{
                    param.id=this.zfModl.id
                }
                updatebrand(param).then((res)=>{
                    if(res.Result != 1) {
                        return this.$message.error(res.Message)
                    }
                    this.showZFModel=false;
                    this.$message.success("操作成功")
                    if(data){
                        this.form.status = '1';
                    }else{
                        this.form.status = '0';
                    }
                    this.getBrandlist();
                })
                console.log("作废")
            },
            closeZFModel(){
                this.showZFModel=false;
            },
            openBrandModl(){
                this.currentlevelParam={
                    update:-1
                }
                this.showBrand=true;
            },
            closeBrand(){
                this.showBrand=false;
            },
            // 重置
            handleReset() {
                this.form = JSON.parse(JSON.stringify(this.oraginForm))
                this.handleSearch()
            },
            // 修改品牌
            openmodfMod(data){
                this.currentlevelParam=data;
                this.currentlevelParam.update=1;
                this.showBrand=true;
            }
            
        }
    }
</script>

<style lang="scss">
    .hands{
        cursor: pointer;
    }
    .customer-list-brand {
        position: relative;

        .next-button {
            position: absolute;
            right: 0;
            top: -56px;
        }
    }
</style>
